interface SearchConfig {
  url: string;
  baseURL?: string;
  params?: object | ((data: any) => object);
  value: string;
  label?: string | ((option: any) => string);
  lazyLoad?: boolean;
}

function injectSearchLib(items: Select[], map: Map<string, Select >) {
  items.forEach(item => {
    const key = item._url
    map.set(key, item)
  })
}

class Select {
  static lib = new Map()
  static injectSearchLib = injectSearchLib
  static use = (url: string): Select => {
    const item = Select.lib.get(url)
    if (!item) {
      console.error(url + '没有在lib中的select中配置')
    }
    const { _url, _baseURL: baseURL, _params: params, _value: value, _label: label } = item
    return new Select({ url: _url, baseURL, params, value, label })
  }

  static copy = (url: string) => Select.use(url)

  public _url = ''
  public _baseURL? = ''
  public _params: object | ((data: any) => object) = {}
  public _value = 'id'
  public _label: string | ((option: any) => string) = ''
  public _lazyLoad = false

  private _prefix = ''

  constructor(search: SearchConfig | string = '') {
    if (typeof search === 'string') {
      this._prefix = search
    } else {
      this._url = search.url
      this._baseURL = search.baseURL
      this._params = search.params || {}
      this._value = search.value
      this._label = search.label || ''
      this._lazyLoad = search.lazyLoad || false
    }
  }

  url(url: string) {
    this._url = url
    return this
  }

  baseURL(baseURL: string) {
    this._baseURL = baseURL
    return this
  }

  params(params?: object | ((data: any) => object)) {
    if (!params) return this
    this._params = params
    return this
  }

  value(value: string) {
    this._value = value
    return this
  }

  label(label: string | ((option: any) => string)) {
    this._label = label
    return this
  }

  lazyLoad(lazyLoad: boolean) {
    this._lazyLoad = lazyLoad
    return this
  }
}

export default Select
